module.exports = __webpack_public_path__ + "static/media/SQLite370.79d07348.svg";